import { colors } from '@configs/styles/config'
import { SVGProps } from 'react'
import * as React from 'react'

export const FreeAudioTranslationIcon: React.FC<SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    width="67"
    height="61"
    viewBox="0 0 67 61"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.0085 57.101H13.6449C14.6486 57.101 15.463 56.2866 15.463 55.2828C15.463 54.279 14.6486 53.4646 13.6449 53.4646H11.0085C7.65162 53.4646 4.91761 50.733 4.91761 47.3737C4.91761 44.0145 7.65162 41.2828 11.0085 41.2828H13.6449C14.6486 41.2828 15.463 40.4684 15.463 39.4647C15.463 38.4609 14.6486 37.6465 13.6449 37.6465H11.0085C5.64419 37.6465 1.28125 42.0094 1.28125 47.3737C1.28125 52.7381 5.64419 57.101 11.0085 57.101Z"
      fill={props.color ? props.color : colors.uguPurple}
      stroke={props.color ? props.color : colors.uguPurple}
    />
    <path
      d="M53.1893 57.101H55.8256C61.19 57.101 65.5529 52.7381 65.5529 47.3737C65.5529 42.0094 61.19 37.6465 55.8256 37.6465H53.1893C52.1855 37.6465 51.3711 38.4609 51.3711 39.4647C51.3711 40.4684 52.1855 41.2828 53.1893 41.2828H55.8256C59.1825 41.2828 61.9165 44.0145 61.9165 47.3737C61.9165 50.733 59.1825 53.4646 55.8256 53.4646H53.1893C52.1855 53.4646 51.3711 54.279 51.3711 55.2828C51.3711 56.2866 52.1855 57.101 53.1893 57.101Z"
      fill={props.color ? props.color : colors.uguPurple}
      stroke={props.color ? props.color : colors.uguPurple}
    />
    <path
      d="M51.3711 57.9188C51.3711 58.9226 52.1855 59.737 53.1893 59.737C54.1931 59.737 55.0075 58.9226 55.0075 57.9188V36.8279C55.0075 35.8242 54.1931 35.0098 53.1893 35.0098C52.1855 35.0098 51.3711 35.8242 51.3711 36.8279V57.9188Z"
      fill={props.color ? props.color : colors.uguPurple}
      stroke={props.color ? props.color : colors.uguPurple}
    />
    <path
      d="M11.8262 57.9188C11.8262 58.9226 12.6406 59.737 13.6444 59.737C14.6481 59.737 15.4625 58.9226 15.4625 57.9188V36.8279C15.4625 35.8242 14.6481 35.0098 13.6444 35.0098C12.6406 35.0098 11.8262 35.8242 11.8262 36.8279V57.9188Z"
      fill={props.color ? props.color : colors.uguPurple}
      stroke={props.color ? props.color : colors.uguPurple}
    />
    <path
      d="M56.6455 39.4645C56.6455 40.4683 57.4599 41.2827 58.4637 41.2827C59.4675 41.2827 60.2819 40.4683 60.2819 39.4645V27.6009C60.2819 12.7879 48.2313 0.737305 33.4183 0.737305C18.6053 0.737305 6.55469 12.7879 6.55469 27.6009V39.4645C6.55469 40.4683 7.36909 41.2827 8.37287 41.2827C9.37665 41.2827 10.191 40.4683 10.191 39.4645V27.6009C10.191 14.7928 20.6128 4.37366 33.4183 4.37366C46.2238 4.37366 56.6455 14.7928 56.6455 27.6009V39.4645Z"
      fill={props.color ? props.color : colors.uguPurple}
      stroke={props.color ? props.color : colors.uguPurple}
    />
    <path
      d="M21.701 41.2828H45.133C46.1387 41.2828 46.9538 40.4691 46.9538 39.4647C46.9538 38.4609 46.1394 37.6465 45.1356 37.6465H21.701C20.6972 37.6465 19.8828 38.4609 19.8828 39.4647C19.8828 40.4684 20.6972 41.2828 21.701 41.2828Z"
      fill={props.color ? props.color : colors.uguPurple}
      stroke={props.color ? props.color : colors.uguPurple}
    />
    <path
      d="M31.5996 39.4644C31.5996 40.4682 32.414 41.2826 33.4178 41.2826C34.4216 41.2826 35.236 40.4682 35.236 39.4644V34.1917C35.236 33.1879 34.4216 32.3735 33.4178 32.3735C32.414 32.3735 31.5996 33.1879 31.5996 34.1917V39.4644Z"
      fill={props.color ? props.color : colors.uguPurple}
      stroke={props.color ? props.color : colors.uguPurple}
    />
    <path
      d="M23.6715 56.1771L23.6709 56.1773C22.7115 56.4644 22.1621 57.4747 22.449 58.4384C22.6826 59.2263 23.4069 59.7373 24.1912 59.7373C24.3639 59.7373 24.5324 59.7118 24.6892 59.6717L24.6989 59.6692L24.7084 59.6664C34.7548 56.6715 41.3112 49.612 43.1138 39.7948C43.2955 38.8085 42.6409 37.8603 41.6555 37.6785L41.6472 37.6769L41.6388 37.6757C40.6706 37.5308 39.7199 38.1398 39.5385 39.1403C37.9957 47.5334 32.3838 53.5826 23.6715 56.1771Z"
      fill={props.color ? props.color : colors.uguPurple}
      stroke={props.color ? props.color : colors.uguPurple}
    />
    <path
      d="M42.1251 59.6611L42.1279 59.6619C42.2975 59.7113 42.4711 59.7372 42.6449 59.7372C43.4289 59.7372 44.1538 59.2263 44.3846 58.4324C44.6741 57.4678 44.1232 56.4583 43.1621 56.1718L43.1619 56.1718C34.4494 53.5771 28.8351 47.5305 27.2949 39.135C27.1138 38.1359 26.1752 37.5257 25.1957 37.6702L25.1868 37.6715L25.1779 37.6731C24.1925 37.8549 23.538 38.803 23.7196 39.7893C25.5195 49.6093 32.0787 56.6689 42.1251 59.6611Z"
      fill={props.color ? props.color : colors.uguPurple}
      stroke={props.color ? props.color : colors.uguPurple}
    />
  </svg>
)
